import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { renderTextArea } from '../../../shared/formComponents';
import Tooltip from '../../../../../shared/components/widgets/Tooltip';

/**
 * Reusable geo-targeting component for Google/Meta/TikTok platforms
 * Shows countries (always), and states/cities/postal codes in Advanced+Limitless only
 */
const GeoTargetingFields = ({
  setupFlow,
  agencyInternal,
  supportsCities = true,
  supportsStates = true,
  supportsPostalCodes = true,
}) => {
  const isAdvancedLimitless = setupFlow?.value === 'advanced' && agencyInternal?.value;

  return (
    <>
      {/* Countries - Limitless View only */}
      {agencyInternal?.value && (
        <div className="form__form-group">
          <span className="form__form-group-label">
            Countries (Optional) <Tooltip id="geoCountries" msg="Enter comma-separated country codes (e.g., geoTargetConstants/2840)" placement="top" />
          </span>
          <div className="form__form-group-field">
            <Field
              name="geoCountries"
              component={renderTextArea}
              placeholder="Geo Target Constant for Conuntry"
            />
          </div>
        </div>
      )}

      {/* States - Advanced + Limitless only */}
      {isAdvancedLimitless && supportsStates && (
        <div className="form__form-group">
          <span className="form__form-group-label">
            States (Optional) <Tooltip id="geoStates" msg="Enter comma-separated state or region codes (e.g., geoTargetConstants/21176)" placement="top" />
          </span>
          <div className="form__form-group-field">
            <Field
              name="geoStates"
              component={renderTextArea}
              placeholder="Geo Target Constant for State"
            />
          </div>
        </div>
      )}

      {/* Cities - Advanced + Limitless only */}
      {isAdvancedLimitless && supportsCities && (
        <div className="form__form-group">
          <span className="form__form-group-label">
            Cities (Optional) <Tooltip id="geoCities" msg="Enter comma-separated city names (e.g., geoTargetConstants/1016367)" placement="top" />
          </span>
          <div className="form__form-group-field">
            <Field
              name="geoCities"
              component={renderTextArea}
              placeholder="Geo Target Constant for City"
            />
          </div>
        </div>
      )}

      {/* Postal Codes - Advanced + Limitless only */}
      {isAdvancedLimitless && supportsPostalCodes && (
        <div className="form__form-group">
          <span className="form__form-group-label">
            Postal Codes (Optional) <Tooltip id="geoPostalCodes" msg="Enter comma-separated postal codes (e.g., geoTargetConstants/9055331)" placement="top" />
          </span>
          <div className="form__form-group-field">
            <Field
              name="geoPostalCodes"
              component={renderTextArea}
              placeholder="Geo Target Constant for Postal Code"
            />
          </div>
        </div>
      )}
    </>
  );
};

GeoTargetingFields.propTypes = {
  setupFlow: PropTypes.shape({
    value: PropTypes.string,
  }),
  agencyInternal: PropTypes.shape({
    value: PropTypes.bool,
  }),
  supportsCities: PropTypes.bool,
  supportsStates: PropTypes.bool,
  supportsPostalCodes: PropTypes.bool,
};

GeoTargetingFields.defaultProps = {
  setupFlow: null,
  agencyInternal: null,
  supportsCities: true,
  supportsStates: true,
  supportsPostalCodes: true,
};

export default GeoTargetingFields;
